/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ group: NonNullable<unknown> }} Assistant_Agent_Editing_BannerInputs */



/**
* | output |
* | --- |
* | "Agent is editing {group} — Stop to edit" |
*
* @param {Assistant_Agent_Editing_BannerInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_agent_editing_banner = /** @type {((inputs: Assistant_Agent_Editing_BannerInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Agent_Editing_BannerInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`L'agent est en train de modifier ${i?.group} — Arrêtez pour modifier`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Agent bearbeitet ${i?.group} — Bearbeitung stoppen`)
	if (locale === "it") return /** @type {LocalizedString} */ (`L'agente sta modificando ${i?.group} — Interrompi per modificare`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Агент редактирует ${i?.group} — Остановить редактирование`)
	if (locale === "es") return /** @type {LocalizedString} */ (`El agente está editando ${i?.group} — Deténgase para editar`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`代理正在编辑 ${i?.group} — 停止编辑`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`エージェントが${i?.group}を編集しています — 編集を停止します`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`एजेंट ${i?.group} को संपादित कर रहा है — संपादन रोकें`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`O agente está editando ${i?.group} — Pare para editar`)
	return /** @type {LocalizedString} */ (`Agent is editing ${i?.group} — Stop to edit`)
});